import clsx from 'clsx';
import CarouserBox from 'components/Carosel/CarouserBox';
import { first } from 'lodash';
import { useEffect } from 'react';
import shopSelectors from 'services/shop/selectors';
import { ICategoryItemData, IServiceItemData } from 'services/shop/types/categories';
import styled from 'styled-components';
type Props = {
  selectedServices: IServiceItemData[];
  activeCategory: ICategoryItemData | null;
  setActiveCategory: (activeCategory: ICategoryItemData) => void;
  v2?: boolean;
};
const Categories = ({ v2, selectedServices = [], activeCategory, setActiveCategory }: Props) => {
  const categories = shopSelectors.data.categoriesIncludeAddon();

  useEffect(() => {
    if (!activeCategory) {
      const item = first(categories);
      if (item) setActiveCategory(item);
    }
  }, []);

  const renderItem = (item: ICategoryItemData) => {
    const amountSelect = selectedServices.filter(o => o.catId === item.id)?.length || 0;
    return (
      <CategoryItem
        label={item.categoryName}
        onClick={() => setActiveCategory(item)}
        active={activeCategory?.id === item.id}
        amountSelect={amountSelect}
      />
    );
  };

  if (v2) {
    return (
      <ContainerV2>
        {categories.map(item => {
          const amountSelect = selectedServices.filter(o => o.catId === item.id)?.length || 0;
          return <CategoryItem
            key={item.id}
            label={item.categoryName}
            onClick={() => setActiveCategory(item)}
            active={activeCategory?.id === item.id}
            amountSelect={amountSelect}
          />;
        })}
      </ContainerV2>
    );
  }

  return (
    <CarouserBox
      content='Catagories'
      list={categories}
      rowPerPage={10}
      colSpan={12}
      gutter={16}
      itemContent={renderItem}
      contentProps={{ className: 'section-label' }}
    />
  );
};

export default Categories;
type CategoryItemProps = {
  active?: boolean;
  label: string;
  amountSelect?: number;
  onClick?: () => void;
};
const CategoryItem = ({ active, amountSelect, label, onClick }: CategoryItemProps) => {

  if (amountSelect) {
    return (
      <CategoryItemStyled className={clsx('CategoryItemStyled selected', active && 'active')} selected active={active} onClick={onClick}>
        <div className='tick-icon'>{active ? <TickIconWhite /> : <TickIconBlack />}</div>
        <div className='content'>
          <div className='label text-overflow'>
            {label || '-'}
          </div>
          <div className='service-text'>{amountSelect} service{amountSelect > 1 ? 's' : ''}</div>
        </div>
      </CategoryItemStyled>
    );
  }

  return (
    <CategoryItemStyled className={clsx('CategoryItemStyled', active && 'active')} active={active} onClick={onClick}>
      <div className="label text-overflow">{label || '-'}</div>
    </CategoryItemStyled>
  );
};

const ContainerV2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const CategoryItemStyled = styled.button <{ selected?: boolean, active?: boolean }>`
    width: 100%;  
    border-bottom: 1px solid var(--line-line-1, #DDD);
    background: var(--button-bg-5, #FFF);
    display:flex;
    align-items: center;
    height: 3.5rem;
    padding: 0 1rem;
    gap: 0.5rem;

    .content {
      max-width: 85%;
    }

    .tick-icon {
      width: 1rem;
    }

    .label {
        color: var(--text-text-3, #1D2129);
        font-family: Poppins;
        font-size: 1.25rem;
        text-transform: uppercase;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: left;
    }

    .service-text {
      color: var(--text-text-2, #767676);
      font-family: Poppins;
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-align: left;
    }

    &:hover {
      background-color: #E5E6EB;
    }

    ${({ selected }) => selected && `
      border-bottom: 1px solid var(--line-line-1, #DDD);
      background: var(--blue-headline, #C6E9EF);
      &:hover {
        background: var(--blue-headline, #C6E9EF);
      }
    `}

    ${({ active }) => active && `
      border-bottom: 1px solid var(--info-infor-3, #6FABB6);
      background: var(--info-infor-3, #6FABB6);
      .label, .service-text {
        color: #fff;
      }
      &:hover {
        background: var(--info-infor-3, #6FABB6);
      }
    `}

`;

const TickIconWhite = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
    <path d="M5.72692 11.7369C5.40676 11.7369 5.10261 11.6088 4.8785 11.3847L0.348172 6.85445C-0.116057 6.39022 -0.116057 5.62184 0.348172 5.15761C0.812402 4.69338 1.58078 4.69338 2.04501 5.15761L5.72692 8.83943L13.955 0.611356C14.4192 0.147126 15.1876 0.147126 15.6518 0.611356C16.1161 1.07559 16.1161 1.84397 15.6518 2.30819L6.57534 11.3847C6.35122 11.6088 6.04707 11.7369 5.72692 11.7369Z" fill="white" />
  </svg>
);

const TickIconBlack = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none">
    <path d="M6.06041 11.7369C5.74025 11.7369 5.4361 11.6088 5.21199 11.3847L0.681668 6.85445C0.217439 6.39022 0.217439 5.62184 0.681668 5.15761C1.1459 4.69338 1.91428 4.69338 2.37851 5.15761L6.06041 8.83943L14.2885 0.611356C14.7527 0.147126 15.5211 0.147126 15.9853 0.611356C16.4496 1.07559 16.4496 1.84397 15.9853 2.30819L6.90883 11.3847C6.68472 11.6088 6.38057 11.7369 6.06041 11.7369Z" fill="#292D32" />
  </svg>
);
